import keyMirror from 'react-utils/keyMirror';
export const ContentTypes = keyMirror({
  QUIZ: null,
  VIDEO: null,
  PRACTICAL_EXERCISE_FLOW: null,
  LINK: null,
  EXAM: null,
  CHAPTER: null
});
export const ContentResourceType = keyMirror({
  COURSE: null,
  MODULE: null,
  LESSON: null,
  TRACK: null
});
export const ResourceItemType = keyMirror({
  QUESTION: null,
  LEARNING_MATERIAL: null,
  PROFESSOR: null
});
const ExternalResourceTypes = keyMirror({
  TRANSCRIPT: null,
  SLIDES: null,
  TEMPLATE: null,
  OTHER: null,
  VIDEO: null,
  BLOG_POST: null,
  EBOOK: null,
  TOOL: null,
  REPORT: null,
  GUIDE: null,
  DOWNLOAD: null,
  WORKBOOK: null,
  PROJECT: null,
  TRAINING: null,
  CHECKLIST: null,
  KNOWLEDGE_BASE: null,
  DOCUMENTATION: null,
  ARTICLE: null,
  FAQS: null,
  TUTORIAL: null,
  EXAMPLES: null,
  CASE_STUDY: null,
  CO_BRANDABLE_EBOOK: null,
  GRAPHIC: null,
  TRACK: null,
  LESSON: null,
  PODCAST: null,
  SPREADSHEET: null,
  WEBSITE: null,
  HUBSPOT_COMMUNITY: null,
  SLACK: null,
  USER_GUIDE: null
});
export const LearningMaterialTypes = ExternalResourceTypes;
export const LinkTypes = ExternalResourceTypes;
export const ContentVisibilityType = keyMirror({
  PUBLIC: null,
  ACADEMY_PARTNER_TRAINING_ACCESS: null,
  PARTNER: null,
  TRAINER: null,
  IN_TRACK_ONLY: null,
  PAYING_CUSTOMER: null,
  MARKETING_SOFTWARE_CERTIFIED: null,
  ENTERPRISE_SALES_PARTNER: null,
  ADVANCED_WEB_IMPLEMENTATION_PARTNER: null,
  MARKETING_IMPLEMENTATION_PARTNER: null,
  PARTNER_TYPES_SALES: null
});